import { useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useDraggable } from "react-use-draggable-scroll";
import { axiosInstanceUnAuthorized } from "../../../API/Axios/AxiosConfig";
import URLS from "../../../API/Axios/URLS";
import StarRatings from "react-star-ratings";


function ReviewCard(item) {
    // random rating from 4 to 5

    function Stars() {
        return (
            <StarRatings
                rating={item?.rating}
                starDimension="25px"
                starRatedColor="#0C98FE"
                isSelectable={false}
                numberOfStars={5}
                name='rating'
            />
        )
    }

    return (
        <div
            className={"flex shadow-md   rounded-xl p-[24px] box-border   flex-col md:justify-between gap-2  bg-white  "}>
            <Stars />
            <p className={"flex mb-auto   "}>
                {item?.review}
            </p>
            <div className={"flex mt-[40px] flex-row items-center gap-2"}>
                <div className={"flex flex-col"}>
                    <span className={"mobile:text-lg md:text-2xl font-bold"}>{item?.review_from}</span>
                    <span className={"mobile:text-sm md:text-lg"}>from {item?.country}</span>
                </div>
            </div>


        </div>
    )
}

export default function LearnerReviews() {
    // const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
    // const {events} = useDraggable(ref);
    const [reviews, setReviews] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        axiosInstanceUnAuthorized.get(URLS.reviews).then((response) => {
            setReviews(response?.data || [])
        })

    }, [])

    const handleNext = () => {
        if (reviews.length > 0) {
            setCurrentIndex((prev) => (prev + 1) % reviews.length);
        }
    };

    const handlePrev = () => {
        if (reviews.length > 0) {
            setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
        }
    };

    const getVisibleReviews = () => {
        if (!reviews || reviews.length === 0) return [];
        const visible = [];
        // Always show 3 items, cycling through the array
        for (let i = 0; i < 3; i++) {
            visible.push(reviews[(currentIndex + i) % reviews.length]);
        }
        return visible;
    };

    return (
        <div
            className="px-[12px]   lg:py-[140px] flex justify-center  items-center box-border py-[18px] lg:px-[148px]">
            <div className={"flex flex-col gap-[80px]"}>
                <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                    <p className={"font-semibold text-[24px] lg:text-[48px] leading-[120%] lg:leading-[120%] text-center"}>
                        What Our <span className={"text-[#0C98FE]"}>Learners</span> Say
                    </p>
                    <p className={" text-[12px] lg:text-[18px] leading-[120%] lg:leading-[120%] text-center"}>
                        Real stories from students who improved their scores with DET Study.
                    </p>
                </div>


                <div className="w-full flex flex-col lg:flex-row items-center gap-6 relative">
                    {/* Desktop Left Arrow */}
                    <button
                        onClick={handlePrev}
                        className="hidden lg:block p-3 rounded-full hover:bg-gray-100 transition-colors text-gray-600 hover:text-[#0C98FE]"
                    >
                        <FaChevronLeft size={32} />
                    </button>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 flex-1 w-full">
                        {getVisibleReviews().map((item, index) => (
                            <ReviewCard key={`${index}-${item.review_from}`} {...item} />
                        ))}
                    </div>

                    {/* Desktop Right Arrow */}
                    <button
                        onClick={handleNext}
                        className="hidden lg:block p-3 rounded-full hover:bg-gray-100 transition-colors text-gray-600 hover:text-[#0C98FE]"
                    >
                        <FaChevronRight size={32} />
                    </button>

                    {/* Mobile Arrows */}
                    <div className="lg:hidden flex gap-8 mt-4">
                        <button
                            onClick={handlePrev}
                            className="p-3 rounded-full bg-gray-50 border border-gray-200 text-gray-600 active:bg-gray-200"
                        >
                            <FaChevronLeft size={24} />
                        </button>
                        <button
                            onClick={handleNext}
                            className="p-3 rounded-full bg-gray-50 border border-gray-200 text-gray-600 active:bg-gray-200"
                        >
                            <FaChevronRight size={24} />
                        </button>
                    </div>
                </div>

            </div>
        </div>
    )
}